module.exports = __webpack_public_path__ + "assets/img/dbd22d118dc055787c284651d5a6de41.svg";